var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.881 25.074 2.23-7.519 3.475-.985.726-2.489-3.421 1.038 3.628-12.34v-.197a.602.602 0 0 0-.622-.58H15.28a.783.783 0 0 0-.777.57L10.2 17.193 6.778 18.23 6 20.614l3.422-1.038L6.362 30h18.252a.772.772 0 0 0 .778-.57l1.037-3.579v-.196a.602.602 0 0 0-.623-.58H13.88z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtc);
export default __webpack_public_path__ + "static/media/LTC.01dc1537eaacc8511d86b8651141e910.svg";
export { ForwardRef as ReactComponent };